import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IGetRedReceiptData {
  id: number,
  bm_type: string,
  aging_interval: number,
  aging_extension: number,
  max_extension: number,
  start_date: string,
  end_date: string,
  create_at: string,
  create_by: string,
  update_at: string,
  update_by: string,
}

export interface IGetRedReceiptResponse {
  listSmplbmaging: IGetRedReceiptData[]
}

const url = "/v1/smplbmaging";

export const getRedReceipt = async (): Promise<IGetRedReceiptResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
  });

  return data;
};
